/* Tennis Lab FX: sticky buy bar for product pages.
   Appears once the buy box scrolls out of view. If the build-your-set panel is on the page it scrolls to it,
   otherwise it presses the page's real Add to cart button. */
(function () {
  'use strict';
  if (window.__tlfxProductLoaded) return;
  window.__tlfxProductLoaded = true;

  var bar = null, io = null, anchorEl = null, shown = false, timer = null;

  function $(s, r) { return (r || document).querySelector(s); }
  function text(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function submitButton(form) {
    return $('[type="submit"][name="add"], .product-form__submit', form) || $('button[type="submit"]', form);
  }

  function readTitle() {
    return text($('.product__title h1')) || text($('.product__title')) || text($('h1')) || document.title;
  }

  function readSize() {
    var checked = $('variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked, fieldset.product-form__input input[type="radio"]:checked');
    if (checked && checked.value) return checked.value;
    var sel = $('variant-selects select, select.select__select');
    return sel && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex].text : '';
  }

  function readPrice() {
    var scope = $('.product__info-container') || document;
    var el = $('.price__container .price-item--last', scope) || $('.price-item--regular', scope) || $('.price-item', scope);
    return text(el);
  }

  function build() {
    var el = document.createElement('div');
    el.className = 'tlfx-buybar';
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'Quick buy');
    el.innerHTML =
      '<div class="tlfx-buybar__text"><span class="tlfx-buybar__title"></span><span class="tlfx-buybar__meta"></span></div>' +
      '<button type="button" class="tlfx-buybar__btn"></button>';
    el.inert = true;
    document.body.appendChild(el);
    return el;
  }

  function refresh() {
    if (!bar) return;
    var form = $('form[action*="/cart/add"]');
    var btnMain = form ? submitButton(form) : null;
    var hasPanel = !!$('[data-tlmb]');
    var soldOut = !hasPanel && btnMain && btnMain.disabled;

    var size = readSize(), price = readPrice();
    $('.tlfx-buybar__title', bar).textContent = readTitle();
    $('.tlfx-buybar__meta', bar).textContent = [size, price].filter(Boolean).join(' · ');

    var btn = $('.tlfx-buybar__btn', bar);
    var notify = $('[data-tlfx-notify]'), notifyOn = !!notify && !notify.hidden;
    btn.textContent = notifyOn ? 'Notify me' : (hasPanel ? 'Choose options' : (soldOut ? 'Sold out' : 'Add to cart'));
    btn.disabled = notifyOn ? false : !!soldOut;
  }

  function setShown(v) {
    if (v === shown || !bar) return;
    shown = v;
    bar.classList.toggle('is-visible', v);
    bar.inert = !v;
    bar.setAttribute('aria-hidden', v ? 'false' : 'true');
  }

  function drawerOpen() {
    return document.body.classList.contains('overflow-hidden') || !!$('cart-drawer.active');
  }

  function onAction() {
    var notify = $('[data-tlfx-notify]');
    if (notify && !notify.hidden) {
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      notify.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
      var field = $('input[type="email"]', notify);
      if (field && field.focus) setTimeout(function () { field.focus({ preventScroll: true }); }, 350);
      return;
    }
    var panel = $('[data-tlmb]');
    if (panel) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      var first = $('input:not(:disabled), select, button', panel);
      if (first && first.focus) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
      return;
    }
    var form = $('form[action*="/cart/add"]');
    var btn = form ? submitButton(form) : null;
    if (btn && !btn.disabled) btn.click();
  }

  function observe() {
    anchorEl = $('[data-tlmb]') || $('form[action*="/cart/add"]');
    if (!anchorEl || typeof IntersectionObserver === 'undefined') return;
    io = new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      // Show only after the buy box has been scrolled past (it is above the viewport), never before reaching it.
      var scrolledPast = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      setShown(scrolledPast && !drawerOpen());
    }, { threshold: [0, 0.01] });
    io.observe(anchorEl);
  }

  function init() {
    if (!$('form[action*="/cart/add"]')) return;            // product pages only
    bar = build();
    $('.tlfx-buybar__btn', bar).addEventListener('click', onAction);
    refresh();
    observe();
    // Keep the label, size and price in step with the variant picker (Dawn changes them without a DOM event we can rely on).
    timer = setInterval(function () {
      refresh();
      if (shown && drawerOpen()) setShown(false);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.__tlfxBuyBar = { refresh: refresh, setShown: setShown };
})();
